export default __webpack_public_path__ + "static/media/download.ce6282de.svg";